import { MARK_CLOSE_TICKET, MARK_CLOSE_TICKET_SUCCESS, MARK_CLOSE_TICKET_ERROR, MARK_CLOSE_TICKET_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const MarkCloseTicket = (state = initialState, action) => {
  switch (action.type) {
    case MARK_CLOSE_TICKET:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case MARK_CLOSE_TICKET_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case MARK_CLOSE_TICKET_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case MARK_CLOSE_TICKET_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default MarkCloseTicket;
